import { onBeforeMount as i, onBeforeUnmount as r, ref as s } from "vue";
import { isBrowser as m } from "./highrise1350.mjs";
const n = s(!1);
function e() {
  n.value = !0;
}
function t() {
  n.value = !1;
}
let o = 0;
function u() {
  return m && (i(() => {
    o || (window.addEventListener("compositionstart", e), window.addEventListener("compositionend", t)), o++;
  }), r(() => {
    o <= 1 ? (window.removeEventListener("compositionstart", e), window.removeEventListener("compositionend", t), o = 0) : o--;
  })), n;
}
export {
  u as useIsComposing
};
